import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const AppleAndroidIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-appleAndroid"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path fill="#fff" d="M52 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0" />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M44 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18m0 2a7 7 0 1 1 0 14 7 7 0 0 1 0-14"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M26.757 21.243a2 2 0 0 1 0-2.828l5.657-5.657a2 2 0 1 1 2.828 2.828l-5.657 5.657a2 2 0 0 1-2.828 0M55 24a2 2 0 0 1-2-2v-8a2 2 0 1 1 4 0v8a2 2 0 0 1-2 2"
        />
        <path fill="#fff" d="M38.5 31.5h4v-5h-4z" />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M42.5 26h-4a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5m-.5 1v4h-3v-4z"
        />
        <path fill="#fff" d="M36 26h16V12H36z" />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M52 11H36a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V12a1 1 0 0 0-1-1m-1 2v12H37V13z"
        />
        <path fill="#fff" d="M45.5 31.5h4v-5h-4z" />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M49.5 26h-4a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5m-.5 1v4h-3v-4z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          d="M42 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m6 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M36.586 2.586a.5.5 0 0 1 .638-.058l.07.058 2.12 2.121a.5.5 0 0 1-.638.765l-.069-.058-2.12-2.12a.5.5 0 0 1 0-.708m14.12 0a.5.5 0 0 1 .766.638l-.058.07-2.121 2.12a.5.5 0 0 1-.765-.638l.058-.069z"
        />
        <path
          fill="#fff"
          className={styles.white}
          d="M27.843 11.493c-2.185-.86-4.212-.518-5.843.432-1.631-.95-3.659-1.293-5.843-.432C13.605 12.498 12 15.054 12 17.797v6.406c0 2.742 1.605 5.298 4.157 6.304 2.184.86 4.212.517 5.843-.432 1.631.95 3.658 1.292 5.843.432C30.395 29.501 32 26.945 32 24.203v-6.406c0-2.743-1.605-5.299-4.157-6.304"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M22.274 10.661 22 10.79l-.012-.005c-1.912-.94-4.06-1.065-6.198-.222-2.903 1.143-4.79 4.044-4.79 7.234v6.406c0 3.189 1.887 6.09 4.79 7.235l.292.108c1.938.684 3.876.58 5.63-.201l.288-.136.013.007c1.912.94 4.059 1.063 6.196.222C31.113 30.293 33 27.392 33 24.203v-6.406c0-3.19-1.887-6.09-4.79-7.234-2.041-.804-4.09-.728-5.936.098m5.202 1.763C29.6 13.26 31 15.413 31 17.797v6.406c0 2.384-1.4 4.537-3.524 5.374-1.746.687-3.451.52-4.973-.366L22 28.918l-.503.293c-1.521.885-3.228 1.053-4.974.366C14.4 28.74 13 26.587 13 24.203v-6.406c0-2.384 1.4-4.537 3.523-5.373 1.747-.689 3.452-.52 4.974.365l.503.293.503-.293c1.522-.886 3.227-1.054 4.973-.365"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M15 23.5a.5.5 0 0 1 .5.5c0 1.38 2.12 3.5 3.5 3.5a.5.5 0 1 1 0 1c-1.933 0-4.5-2.567-4.5-4.5a.5.5 0 0 1 .5-.5"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          d="M15.5 22a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M26.768 6.768c-1.953 1.953-4.071 1.714-5.303 1.768.053-1.232-.185-3.351 1.767-5.304 1.953-1.952 4.072-1.714 5.304-1.767-.054 1.232.185 3.35-1.768 5.303"
        />
      </g>
    </Icon>
  )
}
